import { removeSpecialCharacters } from 'lib/util/string'

/**
 * Parse the brands
 *
 * @param {Array} brands - the list of brands
 * @returns {object} the parsed brands
 */
export default function parseBrands (brands) {
  return brands.reduce((res, brand) => {
    const id = removeSpecialCharacters(String(brand?.id || '').toLowerCase())

    res[id] = {
      ...brand,
      is_available: !!brand?.is_available,
      id,
      image: brand.logo
    }

    return res
  }, {})
}
